import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';
import { Sector } from '../models/sector';
import { environment } from '../../../environments/environment';
import { EducationLevel } from '../models/education-level';
import { JobType } from '../models/job-type';
import { SalaryType } from '../models/salary-type';
import { Country } from '../models/country';
import { Gender } from '../models/gender';
import { TrendingKeywords } from '../models/trending-keywords';
import { Currency } from '../models/currency';

@Injectable({
  providedIn: 'root',
})
export class LookupDataService {
  baseUrl: string = environment.baseApiUrl;

  constructor(private httpClient: HttpClient) {}

  public loadSectors(): Observable<Sector[]> {
    const url = `${this.baseUrl}/sectors`;
    return this.httpClient.get<Sector[]>(url);
  }

  public loadEducationLevels(): Observable<EducationLevel[]> {
    const url = `${this.baseUrl}/educationlevels`;
    return this.httpClient.get<EducationLevel[]>(url);
  }

  public loadJobTypes(): Observable<JobType[]> {
    const url = `${this.baseUrl}/jobtypes`;
    return this.httpClient.get<EducationLevel[]>(url);
  }

  public loadSalaryTypes(): Observable<SalaryType[]> {
    const url = `${this.baseUrl}/salarytypes`;
    return this.httpClient.get<EducationLevel[]>(url);
  }
  public getCountries(): Observable<Country[]> {
    const url = `${this.baseUrl}/countries`;
    return this.httpClient.get<Country[]>(url);
  }

  public loadGenders(): Observable<Gender[]> {
    const url = `${this.baseUrl}/genders`;
    return this.httpClient.get<Gender[]>(url);
  }
  public loadTrendingKeywords(): Observable<TrendingKeywords[]> {
    const url = `${this.baseUrl}/TrendingKeywords`;
    return this.httpClient.get<TrendingKeywords[]>(url);
  }

  public loadCurrencies(): Observable<Currency[]> {
    const url = `${this.baseUrl}/currencies`;
    return this.httpClient.get<Currency[]>(url);
  }

}
